<template>

    <div v-show="show" class="bee_sgin_base_dialog_layout" @click="doClose()">


        <div class="bee_task_dialog_layout">

            <div class="bee_task_success_layout" @click.stop="doc()">


                <div class="bee_content_suceess_main">

                    <div class="check_in_top">
                        <div class="dialog_title">Share</div>
                    </div>




                    <div class="w_r_bg">
                        <div class="check_ll_sp">
                            <a :href="twitter_url" style="text-decoration: none;">
                                <div class="check_ll_ct">
                                    <div class="icon_phone_x"></div>
                                    <div class="check_intor">x</div>
                                </div>
                            </a>
                            <a :href="in_url" style="text-decoration: none;">
                                <div class="check_ll_ct">
                                    <div class="icon_phone_in"></div>
                                    <div class="check_intor">WhatsApp</div>
                                </div>
                            </a>
                            <a :href="tg_url" style="text-decoration: none;">
                                <div class="check_ll_ct">
                                    <div class="icon_phone_tg"></div>
                                    <div class="check_intor">Telegram</div>
                                </div>
                            </a>
                            <a :href="facebook_url" style="text-decoration: none;">
                                <div class="check_ll_ct">
                                    <div class="icon_phone_fb"></div>
                                    <div class="check_intor">Facebook</div>
                                </div>
                            </a>
                        </div>

                        <div class="check_ll_sp">
                            <div class="check_ll_ct" @click="clickCopy">
                                <div class="icon_phone_copy"></div>
                                <div class="check_intor">Copy</div>
                            </div>
                            <div class="check_ll_ct" @click="clickMore">
                                <div class="icon_phone_more"></div>
                                <div class="check_intor">More</div>
                            </div>
                            <div class="check_ll_ct" style="visibility: hidden;">
                                <div class="icon_phone_x"></div>
                                <div class="check_intor">Telegram</div>
                            </div>
                            <div class="check_ll_ct" style="visibility: hidden;">
                                <div class="icon_phone_x"></div>
                                <div class="check_intor">Facebook</div>
                            </div>
                        </div>



                        <div class="nu_dialog_send" @click="doClose()">
                            Cancel
                        </div>
                    </div>


                </div>
            </div>

            <div class="dialog_close_layout">

            </div>
        </div>


    </div>


</template>

<script>

import { addEmit, resultEmitEvent } from "../../util/event.js";

export default {
    name: 'signDialog',
    components: {},
    props: {
        xpNumber: "",
        inviteUrl: "",
    },

    emits: ["copy", "more"],

    data() {
        return {
            isClick: false,
            show: false,
            shareTitle: "Come to Bee.com to collect your " + this.xpNumber + "% XP rewards!",
            shareTxt: "Stay ahead with the latest crypto trends and discover promising potential projects. Arm yourself with knowledge and insights in this bull run!",
            facebook_url: "",
            twitter_url: "",
            email_url: "",
            in_url: "",
            tg_url: "",
        }
    },

    watch: {
        inviteUrl(value) {
            this.facebook_url = 'https://www.facebook.com/sharer.php?t=' + encodeURIComponent("Come to Bee.com to collect your " + this.xpNumber + "% XP rewards!" + this.shareTxt) + encodeURIComponent(this.inviteUrl) + "&u=" + encodeURIComponent(this.inviteUrl);
            this.twitter_url = 'https://x.com/intent/tweet?text=' + encodeURIComponent("Come to Bee.com to collect your " + this.xpNumber + "% XP rewards!" + this.shareTxt) + encodeURIComponent(this.inviteUrl);
            this.email_url = 'mailto:?subject=' + encodeURIComponent("Come to Bee.com to collect your " + this.xpNumber + "% XP rewards!") + '&body=' + encodeURIComponent(this.inviteUrl);
            this.in_url = 'https://wa.me?text=' + encodeURIComponent("Come to Bee.com to collect your " + this.xpNumber + "% XP rewards!" + this.shareTxt) + encodeURIComponent(this.inviteUrl);
            this.tg_url = 'https://t.me/share/url?url=' + encodeURIComponent("Come to Bee.com to collect your " + this.xpNumber + "% XP rewards!" + this.shareTxt) + encodeURIComponent(this.inviteUrl);
        },
    },

    methods: {
        doc() {
            // console.log("===doc===")
        },
        doContet() {
            // console.log("===doContet===")
        },
        doClose() {
            this.show = false;
        },
        showDialog() {
            this.show = true;
        },

        async doCheckin() {
            this.isClick = true;
        },
        clickCopy() {
            this.$emit("copy");
            this.doClose();
        },
        clickMore() {
            this.$emit("more");
            this.doClose();
        },
        showDialog() {
            this.show = true;
        },


    },

    mounted() {


    },


}

</script>

<style scoped>
.icon_app_top_img {
    width: 115px;
    height: 115px;
    margin-bottom: -40px;
    background-size: cover;
    background-repeat: no-repeat;
    box-sizing: border-box;
}



.h_layout {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;
}

.input_css {
    min-height: 32px;
    border: none;
    outline: none;
    border-width: 1px;
    border-color: gray;
    border-radius: 8px;
    min-width: 60%;
}

.bee_sgin_base_dialog_layout {
    position: fixed;
    z-index: 3000;
    transition: transform 700ms;
    background: rgba(0, 0, 0, 0.60);
    width: 100vw;
    height: 100vh;
}

.bee_task_dialog_layout {
    display: flex;
    align-items: center;
    justify-content: end;
    flex-direction: column;
    width: -webkit-fill-available;
    width: -moz-available;
    height: 100vh;
}

.bee_task_success_layout {
    display: flex;
    align-items: center;
    flex-direction: column;
    border-radius: 8px;
    width: -webkit-fill-available;
    width: -moz-available;


}


.bee_content_suceess_main {
    border-radius: 12px;
    /* background: linear-gradient(90deg, #FAFFEF 0%, #FFF4E2 100%); */
    background: #fff;
    align-items: center;
    justify-content: center;
    display: flex;
    flex-direction: column;

    width: -webkit-fill-available;
    width: -moz-available;

}

.dialog_send {
    border-radius: 50px;
    background: #ffc04d;
    color: #FFF;
    text-align: center;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    line-height: 38px;
    /* 166.667% */
    letter-spacing: 0.12px;
    height: 38px;
    margin-top: 24px;
    width: -webkit-fill-available;
    width: -moz-available;
    cursor: pointer;
}

.nu_dialog_send {
    border-radius: 50px;
    border-radius: 28px;
    border: 1px solid #EEE;
    color: #999;
    text-align: center;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    line-height: 38px;
    /* 166.667% */
    letter-spacing: 0.12px;
    height: 38px;
    margin-top: 24px;
    width: -webkit-fill-available;
    width: -moz-available;
}

.nuload_dialog_send {
    border-radius: 50px;
    background: #FFDF9B;
    color: #fff;
    text-align: center;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    line-height: 38px;
    /* 166.667% */
    letter-spacing: 0.12px;
    height: 38px;
    margin-top: 24px;
    width: -webkit-fill-available;
    width: -moz-available;
    justify-content: center;
    display: flex;
}

.dialog_title {
    color: #333;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    margin-top: 4px;
}

.dialog_intro {
    color: #666;
    text-align: center;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin-bottom: 4px;
    display: none;
}

.dialog_msg {
    color: #999;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin-bottom: 26px;
}

.dialog_close_layout {
    display: flex;
    flex-direction: row;
}

.icon_app_close_img {
    width: 28px;
    height: 28px;
    background-size: cover;
    background-repeat: no-repeat;
    box-sizing: border-box;
}

.icon_phone_x {
    width: 44px;
    height: 44px;
    background-size: cover;
    background-repeat: no-repeat;
    background-image: url("https://www.bee.com/wp-content/uploads/2025/03/icon_phone_x.png");
    display: flex;
}

.icon_phone_in {
    width: 44px;
    height: 44px;
    background-size: cover;
    background-repeat: no-repeat;
    background-image: url("https://www.bee.com/wp-content/uploads/2025/03/ic_whatsapp.png");
    display: flex;
}

.icon_phone_tg {
    width: 44px;
    height: 44px;
    background-size: cover;
    background-repeat: no-repeat;
    background-image: url("https://www.bee.com/wp-content/uploads/2025/03/icon_phone_tg.png");
    display: flex;
}

.icon_phone_fb {
    width: 44px;
    height: 44px;
    background-size: cover;
    background-repeat: no-repeat;
    background-image: url("https://www.bee.com/wp-content/uploads/2025/03/icon_phone_fb.png");
    display: flex;
}

.icon_phone_copy {
    width: 44px;
    height: 44px;
    background-size: cover;
    background-repeat: no-repeat;
    background-image: url("https://www.bee.com/wp-content/uploads/2025/03/icon_phone_copy.png");
    display: flex;
}

.icon_phone_more {
    width: 44px;
    height: 44px;
    background-size: cover;
    background-repeat: no-repeat;
    background-image: url("https://www.bee.com/wp-content/uploads/2025/03/icon_phone_more.png");
    display: flex;
}


.checkin_xp {
    width: 134px;
    height: 98px;
}

.check_ll_sp {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: -webkit-fill-available;
    width: -moz-available;
    margin-top: 14px;
}

.check_ll_ct {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.check_time {
    color: #812D15;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
}

.check_intor {
    color: #666;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin-top: 6px;
}

.w_r_bg {
    display: flex;
    flex-direction: column;
    width: -webkit-fill-available;
    width: -moz-available;
    background: #fff;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    align-items: center;
    padding-bottom: 16px;
    padding-left: 16px;
    padding-right: 16px;
}

.check_in_top {
    padding-top: 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    margin-left: 16px;
    margin-right: 16px;
}

.empty_view {
    width: 100vw;
    height: 100vh;
    position: absolute;
    bottom: 0;
}

.loading_logo {
    width: 18px;
    height: 18px;
    background-size: cover;
    background-repeat: no-repeat;
    margin-top: 10px;
    animation: rotate 2s linear infinite;
}

.p_layout {
    display: flex;
    width: -webkit-fill-available;
    width: -moz-available;
}

@keyframes rotate {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}
</style>